import { IEventEnrollment } from '../../../../../store/admin/eventEnrollments/store';
import { IRoundGroup } from '../../../../../store/admin/eventRounds/store';

export const removeGrouped = (
  players: IEventEnrollment[],
  groups: IRoundGroup[]
): IEventEnrollment[] => {
  const groupedPlayers = groups
    ? groups.reduce(
        (ids: number[], group) => ids.concat((group.games || []).map(game => game.enrollment)),
        []
      )
    : [];

  return players ? players.filter(player => !groupedPlayers.includes(player.id)) : [];
};
